import React, { Component } from 'react';
import PubButtons from './PubButtons';

class Pubs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error:null,
      isLoaded:false,
      pubs_from_ids: {}
    };
  }

  componentDidMount() {
    if (this.props.ids) {
      let url = "https://moreygenetics.com/api/read_publications.py?ids="+this.props.ids.join(",");
      console.log(url);
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            this.setState({
              isLoaded: true,
              pubs_from_ids: result
            });
          },
          (error) => {
            this.setState({
              isLoaded:true,
              error
            })
          }
        )
    }
  }

  render() {
    const { error, isLoaded, pubs_from_ids } = this.state;
    
    let pubs_list = [];

    if (this.props.details) {
      pubs_list = this.props.details;
    }
    
    if (error) {
      return (
        <div className='pub_list'>
          <div className='pub'>
            <div className="title">
              {error.message}
            </div>
          </div>
        </div>
      )
    } else if (this.props.ids && !isLoaded) {
      return (
        <div className='pub_list'>
          <div className='pub'>
            <div className="title">
              Loading
            </div>
          </div>
        </div>
      )
    } else {
      pubs_list.push(...Object.values(pubs_from_ids));
    }
    
    pubs_list.sort(function(a,b){
      let y1 = 0; let y2 = 0;
      if ("year" in a) y1 = a.year;
      if ("year" in b) y2 = b.year;
      return y2 - y1;
    })
    
    let pubs_list_divs = [];

    for (let i=0;i<pubs_list.length;i++) {
      var authors, title, pubmed, pmc, year;
      ({ authors, title, pubmed, pmc, year } = pubs_list[i]);

      var left_border = "3px solid darkred";
      if (pmc) {left_border = "3px solid gold"}
      else if (pubmed) {left_border = "3px solid violet"}
      
      pubs_list_divs.push(
        <div className="pub" key={title} style={{borderLeft:left_border}}>
          <PubButtons {...pubs_list[i]}/>
          <div className="title">
            {authors} "{title}" {year}.
          </div>
        </div>
      );
    }

    return(
      <div className="pub_list">
        {pubs_list_divs}
      </div>
    );    
  }
}

export default Pubs;